import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import {
  NgpDialog,
  NgpDialogDescription,
  NgpDialogOverlay,
  NgpDialogTitle,
  NgpDialogTrigger,
} from 'ng-primitives/dialog';
import { ButtonDirective } from '../../primitives/button/button.directive';

@Component({
  selector: 'tc-dialog',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    NgpDialog,
    NgpDialogDescription,
    NgpDialogOverlay,
    NgpDialogTitle,
    NgpDialogTrigger,
    ButtonDirective,
  ],
  template: `
    <button type="button" tcButton [ngpDialogTrigger]="dialog">
      {{ triggerLabel() }}
    </button>

    <ng-template #dialog let-close="close">
      <div ngpDialogOverlay>
        <div ngpDialog>
          @if (title()) {
            <h2 ngpDialogTitle>{{ title() }}</h2>
          }
          @if (description()) {
            <p ngpDialogDescription>{{ description() }}</p>
          }
          <ng-content />
          <div class="flex justify-end gap-2">
            <button type="button" tcButton variant="outline" (click)="close()">
              {{ cancelLabel() }}
            </button>
            <button type="button" tcButton (click)="close()">
              {{ confirmLabel() }}
            </button>
          </div>
        </div>
      </div>
    </ng-template>
  `,
})
export class DialogComponent {
  readonly triggerLabel = input('Open dialog');
  readonly title = input('Dialog title');
  readonly description = input('');
  readonly cancelLabel = input('Cancel');
  readonly confirmLabel = input('Confirm');
}
